module.exports = __webpack_public_path__ + "static/media/organ.2411e78e.svg";